import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './BaseImage.scss';

function BaseImage(props) {
  const { src, alt, className, defaultSrc, ...restProps } = props;

  return (
    <img
      draggable={false}
      src={src || defaultSrc}
      alt={alt}
      className={classnames(styles.image, { [className]: className })}
      {...restProps}
    />
  );
}

BaseImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

BaseImage.defaultProps = {
  className: '',
  alt: 'image',
  src: 'https://ui-avatars.com/api', // TODO add default picture
};

export default BaseImage;



// WEBPACK FOOTER //
// ./src/components/controls/BaseImage.jsx